import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { refreshAccessToken, validateToken } from '../slices/authSlice';
import store from '../store';

const useApiWithAuth = () => {
    const dispatch = useDispatch();
    const { token } = useSelector(state => state.auth);

    const apiCall = useCallback(async (url, options = {}) => {
        if (!token) {
            throw new Error('Aucun token d\'authentification disponible');
        }

        const buildConfig = (currentToken) => ({
            ...options,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${currentToken}`,
                ...options.headers,
            },
        });

        try {
            const response = await fetch(url, buildConfig(token));

            if (response.status === 401) {
                // 1. Essayer le refresh silencieux
                const refreshed = await dispatch(refreshAccessToken());
                if (refreshed) {
                    const newToken = store.getState().auth.token;
                    const retryResponse = await fetch(url, buildConfig(newToken || token));
                    if (!retryResponse.ok) {
                        throw new Error(`Erreur API: ${retryResponse.status} ${retryResponse.statusText}`);
                    }
                    return retryResponse;
                }
                // 2. Refresh échoué → valider le token (fallback legacy)
                const isValid = await dispatch(validateToken());
                if (!isValid) {
                    throw new Error('Session expirée. Veuillez vous reconnecter.');
                }
                const retryResponse = await fetch(url, buildConfig(token));
                if (!retryResponse.ok) {
                    throw new Error(`Erreur API: ${retryResponse.status} ${retryResponse.statusText}`);
                }
                return retryResponse;
            }

            if (!response.ok) {
                throw new Error(`Erreur API: ${response.status} ${response.statusText}`);
            }

            return response;
        } catch (error) {
            console.error('Erreur lors de l\'appel API:', error);
            throw error;
        }
    }, [dispatch, token]);

    return { apiCall };
};

export default useApiWithAuth;
